// src/theme-provider/foundations/colors.ts
var colors = {
  primary: {
    10: "#B2E6FA",
    20: "#66CDF6",
    30: "#00ACF0",
    40: "#008AC0",
    50: "#006790"
  },
  green: {
    10: "#C8F1E8",
    20: "#61A697",
    30: "#1E7461",
    40: "#175D4E",
    50: "#11463A"
  },
  red: {
    10: "#F7D8D4",
    20: "#E9948B",
    30: "#DB4D3D",
    40: "#AF3E31",
    50: "#832E25"
  },
  orange: {
    10: "#FDE5CE",
    20: "#FABF88",
    30: "#F69539",
    40: "#C6782E",
    50: "#965B22"
  },
  blue: {
    10: "#EAF0FE",
    20: "#83A7FA",
    30: "#306CF7",
    40: "#2656C6",
    50: "#132B63"
  },
  neutrals: {
    10: "#FFFFFF",
    20: "#F5F5F5",
    30: "#EDEDED",
    40: "#E0E0E0",
    50: "#C2C2C2",
    60: "#9E9E9E",
    70: "#757575",
    80: "#616161",
    90: "#404040",
    100: "#181818"
  },
  overlay: {
    70: "rgba(24, 24, 24, 0.7)"
  }
};
var colors_default = colors;

export {
  colors_default
};
